import { ChoiceGroup, Stack } from "@fluentui/react";
import React from "react";
import { IResponse, IResponsePost } from "../../../Interfaces/base/IResponse";
import { MensajeBarCorrecto } from "./MensajeBarCorrecto";
import { MensajeBarError } from "./MensajeBarError";
import { MensajeBarAlerta } from "./MensajeBarAlerta";

export const MensajeBar = (props: IResponse) => {
  return (
    <>
      {props.response?.codigoMensaje === 1 && <MensajeBarCorrecto mensaje={props.response.mensaje} onDismiss={props.ocultar} />}
      {props.response?.codigoMensaje === 2 && <MensajeBarAlerta mensaje={props.response.mensaje} onDismiss={props.ocultar} />}
      {props.response?.codigoMensaje === 3 && <MensajeBarError mensaje={props.response.mensaje} onDismiss={props.ocultar}/>}
    </>
  );
};
